// Initialize and add the map

let map;

async function initMap() {
    // Datapas location
    const position = { lat: 52.3879783, lng: 4.6312996 };

    // Request needed libraries.
    //@ts-ignore
    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

    // The map, centered at Uluru
    map = new Map(document.getElementById("map"), {
        zoom: 15,
        center: position,
        mapId: "map",
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false
    });

    // // The marker, positioned at Uluru
    const marker = new AdvancedMarkerElement({
        map: map,
        position: position,
        title: "Datapas",
    });

    !function () {
        "use strict";
        for (var e = ["ContentModuleLoaded", "PageLoaded", "NodeCreated"], o = 0; o < e.length; o++) document.addEventListener("Neos." + e[o], initMap)
    }();
//# sourceMappingURL=Backend.js.map
}

if ($("#googleMapsSection").length > 0 ) {
    initMap();
}
